/**
 * Import polyfills
 */
import "./js/polyfills";

/**
 * Shopify API Initialization
 */
import "./js/shopify";

/**
 * Dialog Close on Backdrop Click
 */
document.addEventListener("click", (event) => {
  if (event.target.tagName === "DIALOG") {
    event.target.close();
  }
});

import Fuse from 'fuse.js'
window.Fuse = Fuse

/**
 * AlpineJS Initialization
 */

import "./js/directives";
import "./js/magics";
import "./js/components";

import Alpine from "alpinejs";
import anchor from "@alpinejs/anchor";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";
import clipboard from "@ryangjchandler/alpine-clipboard";

window.Alpine = Alpine;

Alpine.plugin(anchor);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(clipboard);

Alpine.start();

/**
 * Dispatch Base Ready Event
 */
window.dispatchEvent(new CustomEvent("base:ready"));
